import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Import modular language files
import navEn from './locales/nav/en.json'
import navZh from './locales/nav/zh.json'
import activationEn from './locales/activation/en.json'
import activationZh from './locales/activation/zh.json'
import knowledgeEn from './locales/knowledge/en.json'
import knowledgeZh from './locales/knowledge/zh.json'
import poisoningEn from './locales/poisoning/en.json'
import poisoningZh from './locales/poisoning/zh.json'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang

Vue.use(VueI18n)

// Combine all modules into messages
const messages = {
  en: {
    ...elementEnLocale,
    nav: navEn,
    activation: activationEn,
    knowledge: knowledgeEn,
    poisoning: poisoningEn
  },
  zh: {
    ...elementZhLocale,
    nav: navZh,
    activation: activationZh,
    knowledge: knowledgeZh,
    poisoning: poisoningZh
  }
}

const i18n = new VueI18n({
  locale: 'en', // set default locale
  fallbackLocale: 'en',
  fallbackWarn:false,
  missingWarn:false,
  messages,
  silentTranslationWarn: true
})


export default i18n
